__turbopack_context__.v({
  "card": "ParagraphTwoPaths-module__LIj-nq__card",
  "cardHeader": "ParagraphTwoPaths-module__LIj-nq__cardHeader",
  "desc": "ParagraphTwoPaths-module__LIj-nq__desc",
  "eyebrow": "ParagraphTwoPaths-module__LIj-nq__eyebrow",
  "grid": "ParagraphTwoPaths-module__LIj-nq__grid",
  "header": "ParagraphTwoPaths-module__LIj-nq__header",
  "iconBox": "ParagraphTwoPaths-module__LIj-nq__iconBox",
  "name": "ParagraphTwoPaths-module__LIj-nq__name",
  "section": "ParagraphTwoPaths-module__LIj-nq__section",
  "title": "ParagraphTwoPaths-module__LIj-nq__title",
});
